<template>
    <vParameterComponent :postList="postList" v-if="flag"></vParameterComponent>
</template>
<script>
import vParameterComponent from '../../listComponent/basicdata/parameter/parameterComponent.vue';
export default {
    name: 'parameterList',
    components: {
        vParameterComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>